/**
 * AI.GEN lines=1-60
 * 钉钉登录服务 - 参考旧调度项目实现
 */
import Cookies from 'js-cookie';

import { domainEnum, tokenNameEnum } from '@/common/enum';
import { countryCode } from '@/config/country';
import { host } from '@/config/host';

type IAppEnv = 'release' | 'beta' | 'dev' | 'test';
const appEnv = (process.env.environment || 'test') as IAppEnv;
const tokenName =
  appEnv === 'release' ? tokenNameEnum[countryCode] || 'CN_token' : 'CN_token';
const domain = domainEnum[appEnv] || domainEnum.test;

export default class DingTalkLogin {
  static getToken() {
    return Cookies.get(tokenName) || Cookies.get('token');
  }

  static setToken(value: string) {
    Cookies.set(tokenName, value, { domain, path: '/' });
    Cookies.set('token', value, { domain, path: '/' });
  }

  static removeToken() {
    Cookies.remove(tokenName, { domain, path: '/' });
    Cookies.remove('token', { domain, path: '/' });

    Object.values(domainEnum).forEach((item: string) => {
      Cookies.remove(tokenName, { domain: item, path: '/' });
      Cookies.remove('token', { domain: item, path: '/' });
    });
  }

  static jumpToLogin() {
    // 开发环境
    const countryHost = host[countryCode];
    let origin =
      countryHost?.SERVER_URMS_URL ||
      'https://f2e-urms-test.hungrypanda.cn/ssoLogin';
    const loginUrl = `${origin}?sourceSiteUrl=${window.location.origin}&sourceId=3`;
    window.location.replace(loginUrl);
  }

  static init() {
    const token = Cookies.get(tokenName) || Cookies.get('token');
    if (token) {
      Cookies.set('token', token, { domain, path: '/' });
    } else {
      this.removeToken();
      this.jumpToLogin();
    }
  }
}
